import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_API
});

instance.interceptors.request.use((config) => {
  const token = document.querySelector('[name=csrf-token]').content
  instance.defaults.headers.common['X-CSRF-TOKEN'] = token
  return config;
});

export default instance;
